
export class VehiclePosition {
    latitude: number;
    longitude: number;
    bearing?: number;
    bearingText?: string;
    speed?: number;
    timestamp?: Date;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);

            if (this.bearing) {
                this._calculateBearingText();
            } else {
                this.bearingText = '-';
            }
        }
    }

    setBearing(bearing: number): void {
        this.bearing = bearing;
        this._calculateBearingText();
    }

    private _calculateBearingText() {
        // 1. Shift degrees with segmentsize
        // 2. Handle degrees > 360 due to shifting
        // 3. Get text by index.

        const texts = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
        const segmentDegrees = 360 / texts.length;
        const index = Math.floor(((this.bearing + segmentDegrees / 2) % 360) / segmentDegrees);
        this.bearingText = texts[index];
    }
}
